export default __webpack_public_path__ + "static/ray-140ab6cd794b0fab08bc1852564c4d88.png";